var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echarts-element-class",attrs:{"id":_vm.id}},[_c('div',{staticStyle:{"display":"none"}},[_vm._v(_vm._s(_vm.optionUpdated))])])
}
var staticRenderFns = []

export { render, staticRenderFns }